import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [orderCount, setOrderCount] = useState(0);
  const location = useLocation();

  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const updateOrderCount = () => {
      const savedItems = localStorage.getItem('selectedOrderItems');
      if (savedItems) {
        try {
          const items = JSON.parse(savedItems);
          setOrderCount(items.length);
        } catch {
          setOrderCount(0);
        }
      } else {
        setOrderCount(0);
      }
    };

    updateOrderCount();
    window.addEventListener('storage', updateOrderCount);
    window.addEventListener('orderItemsUpdated', updateOrderCount);

    return () => {
      window.removeEventListener('storage', updateOrderCount);
      window.removeEventListener('orderItemsUpdated', updateOrderCount);
    };
  }, [location]);

  const navItems = [
    { name: 'Home', href: '#home' },
    { name: 'Products', href: '#products' },
    { name: 'Services', href: '#services' },
    { name: 'About', href: '#about' },
    { name: 'Contact', href: '#contact' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img 
              src="https://public.readdy.ai/ai/img_res/155a86ff-0858-4fd7-8047-16b3237463e4.jpg"
              alt="Cheers Wines & Spirits"
              className="h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {isHomePage ? (
              <>
                <a href="#home" className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 font-medium">Home</a>
                <a href="#products" className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 font-medium">Products</a>
              </>
            ) : (
              <>
                <Link to="/" className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 font-medium">Home</Link>
                <Link to="/#products" className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 font-medium">Products</Link>
              </>
            )}
            {navItems.slice(2).map((item) => (
              <a
                key={item.name}
                href={item.name === 'Products' ? '/#products' : item.href}
                className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 font-medium"
              >
                {item.name}
              </a>
            ))}
          </nav>

          <div className="flex items-center space-x-4">
            <Link to="/order" className="relative cursor-pointer">
              <Button variant="primary" size="sm">
                Order Now
              </Button>
              {orderCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center">
                  {orderCount}
                </span>
              )}
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-yellow-400 hover:text-yellow-300 transition-colors"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-yellow-400/20">
            <nav className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <a
                  key={item.name}
                  href={item.name === 'Products' ? '/#products' : item.href}
                  className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 font-medium"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.name}
                </a>
              ))}
              <div className="pt-4">
                <Link to="/order" className="block w-full">
                  <Button variant="primary" size="sm" className="w-full">
                    Order Now
                  </Button>
                </Link>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
